import { createStore } from 'redux';
import reducers from './reducers';
import { persistStore } from 'redux-persist';

const store = createStore(reducers);

export type AppDispatch = typeof store.dispatch;

export default function configureStore() {
  const store = createStore(reducers);
  const persistor = persistStore(store);
  return { store, persistor };
}
